import type { ReactNode } from 'react';
import { cn } from '@/shared/utils/utils';

/** Standard page width + padding wrapper for content under the AppShell. */
export function ContentContainer({
  children,
  className,
  title,
}: {
  children: ReactNode;
  className?: string;
  title?: string;
}) {
  return (
    <div className={cn('mx-auto w-full max-w-[1400px] p-4 md:p-6', className)}>
      {title && <h1 className="mb-4 text-title-lg font-semibold text-on-surface">{title}</h1>}
      {children}
    </div>
  );
}
